"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = withoutDigits;
function withoutDigits(string) {
  if (string === undefined) {
    return string;
  }
  return string.replace(/\d/g, '');
}